module.exports = __webpack_public_path__ + "static/media/6.a2b8f622.png";